import React, { ChangeEvent } from 'react';
import { PromotionPlace } from '@api/graphql/types';

interface Props {
    name: string;
    value: PromotionPlace | null | undefined;
    placeholder?: string;
    hint?: string;
    required?: boolean;
    onChangeHandler: (value: any, name: string) => void;
}

const PromotionPlaceSelect = (props: Props) => {
    const {value, name, onChangeHandler} = props;
    return (
        <>
            <select className="form-control" value={value ? value.toString() : ''} onChange={(e: ChangeEvent<HTMLSelectElement>) => {onChangeHandler(e.currentTarget.value, name); }}>
                {!props.required && <option value={''}>---</option>}
                {Object.keys(PromotionPlace).map((key: string) => <option value={PromotionPlace[key]} key={key}>{PromotionPlace[key]}</option>)}
            </select>
            {props.hint && <span className="form-text m-b-none">{props.hint}</span>}
        </>
    );
};

export default PromotionPlaceSelect;



// WEBPACK FOOTER //
// ./src/components/Form/PromotionCategorySelect.tsx